import { RESIZE_HANDLER_DElAY } from "./ApplicationConfig";
import state from "./ApplicationState";
import DelayedCall from "./DelayedCall";

let timeoutId = null;

/**
 * Добавление обработчика события resize в список обработчиков
 * 
 * @param handler Обработчик события resize
 * @param context Контекст вызова обработчика
 */
export default function addResizeHandler(handler: Function, context: any = null, ...params)
{
    handler = handler.bind(context, ...params);
    state.resizeHandlersList.push(handler);
}

export function listenResizeEvent()
{
    const runListeners = (evt) => {
        // обработчики ресайза в данной реализации выполняются последовательно. Возможно это не лучшее решение и нужно
        // просто навесить обаботчики при помощи addEventListener
        state.resizeHandlersList.forEach(handler => handler(evt));
    };

    let delayedCall = new DelayedCall();

    window.addEventListener('resize', e => {
        delayedCall.execute(runListeners, RESIZE_HANDLER_DElAY, null, e);
    });
}
